<template>
  <v-card class="dash-card">
    <v-card-title class="dash-title" :style="'background: ' + (cardValues['color'] ? cardValues['color'] : '#00acc2')">
      <h2 class="dash-title-text">{{this.cardValues['id_text']}}</h2>
      <v-spacer></v-spacer>
      <div class="dash-title-text" v-if="pagination['total'] > qtdItens">
        <v-btn flat icon :disabled="pagination['total'] === 0 || pagination['current_page'] === 1" @click="getItems(pagination['current_page'] - 1)" color="white" style="margin: 0;">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <strong v-if="pagination['total'] === 0">0 - 0 de 0</strong>
        <strong v-else>{{this.pagination['from']}} - {{this.pagination['to']}} de {{this.pagination['total']}}</strong>
        <v-btn flat icon :disabled="pagination['current_page'] === pagination['last_page']" @click="getItems(pagination['current_page'] + 1)" color="white" style="margin: 0;">
          <v-icon>arrow_forward</v-icon>
        </v-btn>
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <v-btn slot="activator" class="dash-title-btn" flat icon @click="$emit('filtersItem', cardValues['i'])" :disabled="!checkPermission('dashboard_custom', 'manage')">
          <v-badge left bottom :value="qtdFilters > 0" class="dash_badge" :color="cardValues['color'] ? cardValues['color'] : '#00acc2'">
            <template v-slot:badge>
              <span>{{qtdFilters}}</span>
            </template>
            <v-icon color="white">filter_list</v-icon>
          </v-badge>
        </v-btn>
        <span>{{checkPermission('dashboard_custom', 'manage') ? 'Filtrar' : 'Sem permissão para filtrar'}}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" class="dash-title-btn" :disabled="!checkPermission('dashboard_custom', 'edit')" flat icon @click="$emit('editItem', cardValues['i'])">
          <v-icon color="white">edit</v-icon>
        </v-btn>
        <span>{{checkPermission('dashboard_custom', 'edit') ? 'Editar' : 'Sem permissão para editar'}}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" class="dash-title-btn" :disabled="!checkPermission('dashboard_custom', 'delete')" flat icon @click="$emit('deleteItem', cardValues['i'])">
          <v-icon color="white">close</v-icon>
        </v-btn>
        <span>{{checkPermission('dashboard_custom', 'delete') ? 'Excluir' : 'Sem permissão para excluir'}}</span>
      </v-tooltip>
    </v-card-title>    <v-divider></v-divider>
    <v-card-text style="padding: 0px;width: 100%;height: 90%;overflow: auto;">
      <v-layout v-if="loading" align-center justify-center row fill-height>
        <img :src="`${basePath}images/loader.gif`" width="100px"/>
      </v-layout>
      <v-data-table v-else :headers="headers" :items="items" hide-actions class="small-data-table" style="width: 100%;height: 100%;" :no-data-text="translate('system.table.emptyTable')" id="dashboard_data_table">
        <template slot="items" slot-scope="myprops">
          <tr class="table-tr">
            <td v-for="(header, index) in headers" class="table-td" :key="index" :width="header['width']">
              {{getItemValue(myprops.item[header['value']], header['type'])}}
            </td>
          </tr>
        </template>
        <template v-slot:footer>
          <!-- // caso seja big number pega o header total que traz apenas os registros que não são agrupados -->
          <!-- <tr v-if="cardValues['is_big_number']" class="table-tr">
            <td v-for="(header, index) in headersTotal" :key="index">
              <strong>{{ getItemValue(itemsTotal[header['value']], header['type']) }}</strong>
            </td>
          </tr> -->
          <!-- <tr v-else class="table-tr"> -->
          <tr class="table-tr">
            <td v-for="(header, index) in headers" :key="index">
              <strong v-if="index === 0">Total Geral: {{ getItemValue(itemsTotal[header['value']], header['type']) }}</strong>
              <strong v-else>{{ getItemValue(itemsTotal[header['value']], header['type']) }}</strong>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
    <!-- <v-divider></v-divider> -->
    <!-- <v-card-actions>
      <v-flex>
        <v-data-table :headers="headersTotal" :items="itemsTotal" hide-actions hide-headers>
          <template slot="items" slot-scope="myprops">
            <td v-for="(header, index) in headersTotal" :key="index" :width="header['width']" class="table-td-total">
            {{ myprops.item[header.value] }}
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-actions> -->
  </v-card>
</template>

<style scoped>
  .table-header {
    font-size: 18px !important;
    font-weight: 900 !important;
  }
  .table-td {
    height: 40px !important;
    font-size: 16px !important;
  }
  .table-tr {
    height: 40px !important;
  }
  .dash-card {
    border-radius: 13px;
    width: 100%;
    height: 100%;
  }
  .dash-title {
    padding: 0px;
    height: 45px;
  }
  .dash-title-text {
    padding-left: 20px;
    color: #fff;
    margin-bottom: 16px;
  }
  .dash-title-btn {
    margin-bottom: 20px;
  }
</style>

<script>
  /* eslint-disable no-unneeded-ternary, eqeqeq */
  import access from '../../../mixin/access'
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'
  momentDurationFormatSetup(moment)

  export default {
    mixins: [access],
    props: {
      cardValues: {
        type: Object,
        default: () => { return {} }
      },
      dashboardId: {
        type: Number,
        default: 0
      }
    },
    data: () => ({
      pagination: {total: 0},
      qtdItens: 5,
      qtdFilters: 0,
      items: [],
      itemsTotal: [],
      headers: [],
      // headersTotal: [],
      basePath: process.env.API,
      loading: false
    }),
    created () {
      this.getItems()
    },
    methods: {
      reloadItems (loading = true) {
        this.getItems(this.pagination['current_page'], loading)
      },
      getItems (page = 1, loading = true) {
        let selectedBoard = this.$store.getters[`selectedBoard/values`]
        let params = {
          taskBoardId: selectedBoard['id'],
          dashboardId: this.dashboardId,
          cardI: this.cardValues['i'],
          perPage: this.qtdItens,
          page: page
          // search: this.search,
        }
        if (loading) this.loading = true
        this.$http.post(`api/get_filtered_tasks?`, params).then(res => {
          this.getHeaders()
          this.getQtdFilters()
          this.items = res.body.data
          this.pagination = {
            total: res.body.total,
            per_page: res.body.per_page,
            current_page: res.body.current_page,
            last_page: res.body.last_page,
            from: res.body.from,
            to: res.body.to
          }
          this.loading = false
          // coloca o setTimeout pra dar tempo de carregar a tabela
          setTimeout(() => {
            // Tira a classe v-table__overflow pois ela estava atrapalhando o overflow
            document.getElementById('dashboard_data_table').getElementsByClassName('v-table__overflow')[0].classList.remove('v-table__overflow')
          }, 300)
        }, err => {
          console.log(err)
          this.loading = false
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', { text: 'Não foi possível carregar os dados. Reporte o erro.', color: 'error', dialog: true })
        })
        params['isOnlyTotal'] = true
        this.$http.post(`api/get_filtered_tasks?`, params).then(res => {
          this.itemsTotal = res.body
          // this.getHeadersTotal()
        }, err => {
          console.log(err)
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', { text: 'Não foi possível carregar os totais. Reporte o erro.', color: 'error', dialog: true })
        })
      },
      // Função para pegar a quantidade de filtros existentes para colocor no badge do icone de filtro
      getQtdFilters () {
        this.qtdFilters = 0
        let filters = this.cardValues['filters']
        for (var prop in filters) {
          // caso a propriedade não seja vazia adiciona 1
          if (!(filters[prop] == '' || filters[prop] == [])) this.qtdFilters++
        }
      },
      getItemValue (value, type) {
        let result = ''
        switch (type) {
          case 'value':
            result = value ? parseFloat(value) : 0
            result = result.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'})
            break
          case 'number':
            result = value ? value : 0
            break
          case 'time':
            result = (value > 0) ? moment.duration(parseInt(value), 'seconds').format('hh:mm:ss', {trim: false}) : 0
            break
          default:
            result = value ? value : ''
        }
        return result
      },
      // criado para ordenar os headers com o agrupamento primeiro
      getHeaders () {
        this.headers = []
        this.cardValues['grouping_fields'].forEach(field => {
          this.headers.push({text: field['text'], value: field['value'], class: 'table-header', type: field['type']})
        })
        this.cardValues['fields'].forEach(field => {
          // verifica se o campo já não foi adicionado pelo agrupamento e adiciona
          if (!this.cardValues['grouping_fields'].some((val) => val['value'] === field['value'])) {
            let aggregateFunction = ''
            // caso não tenha agrupamento, então todos os campos vem normal
            if (this.cardValues['grouping_fields'].length > 0) aggregateFunction = ['value', 'number'].includes(field['type']) ? '(Soma)' : '(Qtd)'
            this.headers.push({text: field['text'] + aggregateFunction, value: field['value'], type: field['type'], class: 'table-header'})
          }
        })
      }
      // getHeadersTotal () {
      //   this.headersTotal = []
      //   this.cardValues['fields'].forEach(field => {
      //     let isGrouping = this.cardValues['grouping_fields'].some((val) => val['value'] === field['value'])
      //     // verifica se o campo já não possui no agrupamento, pois os agrupados não deveme ir
      //     if (!this.cardValues['is_big_number'] || !isGrouping) this.headersTotal.push({text: field['text'], value: field['value'], type: field['type'], class: 'table-header'})
      //   })
      // }
    }
    // computed: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboardCustom/cards/CardTable.vue